module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_avatar-7046a222cc7d7cb7fbce6017f25e6b95.svg";